export const BLOG_PAGE_SIZE = 9;
